import { render, staticRenderFns } from "./formOptionGroup.vue?vue&type=template&id=02160a19&"
import script from "./formOptionGroup.vue?vue&type=script&lang=js&"
export * from "./formOptionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports